import React from 'react';
import { css } from 'twin.macro';

const MessageEdited = ({ msgEdited, isSenderMessage }) => {
    if (!msgEdited) {
        return null;
    }
    if (isSenderMessage) {
        return <div className="edited-label"> Edited</div>;
    }
    return (
        <div
            css={css`
                font-size: 1.1rem;
                display: flex;
                padding: 0 5px !important;
                font-style: italic;
                justify-content: flex-start;
            `}
        >
            <span className="ml-1">Edited</span>
        </div>
    );
};

export default MessageEdited;
